import { EntryType } from "../../../../../../api/tournament-participant";
import { Title } from "../../../../../../styles/page";
import { useParticipantContext } from "../../hooks/participant-context";
import {
  ControllerQrReEntryItem,
  ControllerQrReEntryItemWrapper,
  ControllerQrReEntryWrapper,
} from "./style";

const ControllerQrReEntryPopup = () => {
  const {
    setIsReEntryPopup,
    setReEntryType: setEntryType,
    setIsCount,
    setIsQrReEntryPopup,
  } = useParticipantContext();

  const handleClick = () => {
    setIsQrReEntryPopup(false);
    setIsReEntryPopup(true);
  };

  return (
    <ControllerQrReEntryWrapper>
      <Title size={20}>QR 참가 방식 선택</Title>
      <ControllerQrReEntryItemWrapper>
        <ControllerQrReEntryItem
          onClick={() => {
            setEntryType(EntryType.RE_BUY);
            handleClick();
          }}
        >
          리엔트리
        </ControllerQrReEntryItem>
        <ControllerQrReEntryItem
          onClick={() => {
            setEntryType(EntryType.ADD_ON);
            setIsCount(true);
            handleClick();
          }}
        >
          애드온<span>(엔트리 포함 O)</span>
        </ControllerQrReEntryItem>
        <ControllerQrReEntryItem
          onClick={() => {
            setEntryType(EntryType.ADD_ON);
            setIsCount(false);
            handleClick();
          }}
        >
          애드온<span>(엔트리 포함 X)</span>
        </ControllerQrReEntryItem>
        <ControllerQrReEntryItem
          isCancel={true}
          onClick={() => setIsQrReEntryPopup(false)}
        >
          취소
        </ControllerQrReEntryItem>
      </ControllerQrReEntryItemWrapper>
    </ControllerQrReEntryWrapper>
  );
};

export default ControllerQrReEntryPopup;
